// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"4746713a","424":"da562ee9","787":"7f3825d8","874":"1f8413e4"}[chunkId] + ".chunk.js";
};